import React, { useEffect, useRef, useState } from "react";
import { FaExpandArrowsAlt, FaCompressArrowsAlt, FaComment, FaCamera, FaDesktop, FaPortrait, FaVolumeUp } from "react-icons/fa";
import { BsThreeDots } from "react-icons/bs";
import { TbDeviceDesktopUp } from "react-icons/tb";
import { useTranslation } from "react-i18next";

import ConstData from "../../../lib/ConstData";
import { getAudioSourceSettings, isAndroidWebView, isIOSWebView, setAudioSourceSettings } from "../../../lib/HandsUpClient";
import { MEDIA_SOUP_DISPLAY_ROTATION_STATUS_EVENT, sendUpdateDisplayRotation } from "../../../lib/MediaSoupClient"; // 260916 화면 보정 기능

const LiveControlTool = ({ userNickname, performLiveInfo, performLiveStatusInfo, performHandsUpStatusInfo, classTalkVisibility, teacherViewVisibility, myCamViewVisibility, optionVisibility, publicClassVisibility, isFullScreenMode, viewKind, isClassMonitorMaximized, handleSelectedLiveFunc }) => {
    const { t } = useTranslation();

    const [teacherInfo, setTeacherInfo] = useState(performLiveInfo.teacher_info ? performLiveInfo.teacher_info : { userSeq: -1, userNickname: "" });
    // const [optionMode, setOptionMode] = useState(false);
    // const [liveSeq, setLiveSeq] = useState(performLiveInfo.liveSeq ? performLiveInfo.liveSeq : -1);
    // const [handsUpYN, setHandsUpYN] = useState(performLiveInfo.handsUpYN ? performLiveInfo.handsUpYN : "N");

    // const [isConnect, setIsConnect] = useState(performLiveStatusInfo.isConnect !== undefined && performLiveStatusInfo.isConnect !== null ? performLiveStatusInfo.isConnect : false);
    // const [myHandsUpYN, setMyHandsUpYN] = useState(performHandsUpStatusInfo.myHandsUpYN ? performHandsUpStatusInfo.myHandsUpYN : "N");
    // const [connectStatus, setConnectStatus] = useState(performHandsUpStatusInfo.connectStatus ? performHandsUpStatusInfo.connectStatus : "disable");
    // const [micStatus, setMicStatus] = useState(performHandsUpStatusInfo.micStatus ? performHandsUpStatusInfo.micStatus : "disable");

    const [isClassTalkNotifying, setIsClassTalkNotifying] = useState(false);

    // 20260910 실제 -90도 화면 공유 producer가 생성된 경우에만 내 이름 옆 상태 배지를 표시한다.
    const [isScreenRotationSending, setIsScreenRotationSending] = useState(false);

    // 260916 화면 보정 기능: 90/180/270도 선택 메뉴 열림 상태와, 현재 내가 선택한 회전값.
    const [isScreenCorrectionMenuOpen, setIsScreenCorrectionMenuOpen] = useState(false);
    const [selectedDisplayRotation, setSelectedDisplayRotation] = useState(0);

    // 20261001 기존 더보기 메뉴 안에서만 표시하는 단말 소리 입력 설정 상태다.
    const [isAudioSourceSettingsOpen, setIsAudioSourceSettingsOpen] = useState(false);
    const [audioSourceSettings, setAudioSourceSettingsState] = useState({ microphoneIncluded: true, systemAudioIncluded: true });
    const [audioSourceSettingsMessage, setAudioSourceSettingsMessage] = useState("");
    const [pendingAudioSourceSettingsRequestId, setPendingAudioSourceSettingsRequestId] = useState("");
    const audioSourceSettingsRequestRef = useRef("");
    const audioSourceSettingsTimeoutRef = useRef(null);
    const audioSourceSettingsContainerRef = useRef(null);
    const isAndroidClient = isAndroidWebView();
    const isIOSClient = isIOSWebView();
    // [261015-IOS-COMPAT] 하위호환: 앱이 소리 설정 지원을 알려오지 않은(이전) iOS 앱이면 기존 UI/동작 유지.
    // 모든 사용자가 새 앱으로 업데이트되면 isIOSLegacyApp 관련 분기를 [261015-IOS-COMPAT] 검색해 일괄 제거.
    const isIOSLegacyApp = isIOSClient && window.isIOSNativeAudioSourceSupported !== true;

    // 260916 화면 보정 옵션을 선택하면 producer 재생성 없이 서버로 회전값 갱신을 요청한다.
    const handleSelectDisplayRotation = (rotation) => {
        setSelectedDisplayRotation(rotation);
        setIsScreenCorrectionMenuOpen(false);
        sendUpdateDisplayRotation(rotation);
    };

    window.updateClassTalkNotification = (isActive) => {
        console.log("updateClassTalkNotification - isActive:", isActive);
        setIsClassTalkNotifying(isActive);
    };

    useEffect(() => {
        const handleClassTalkNotification = (e) => {
            console.log("handleClassTalkNotification - e.detail.active => ", e.detail.active);
            setIsClassTalkNotifying(e.detail.active);
        };

        window.addEventListener("classTalkNotification", handleClassTalkNotification);
        return () => window.removeEventListener("classTalkNotification", handleClassTalkNotification);
    }, []);

    useEffect(() => {
        const handleDisplayRotationStatus = (e) => {
            setIsScreenRotationSending(e.detail && e.detail.displayRotation === -90);
        };

        window.addEventListener(MEDIA_SOUP_DISPLAY_ROTATION_STATUS_EVENT, handleDisplayRotationStatus);
        return () => window.removeEventListener(MEDIA_SOUP_DISPLAY_ROTATION_STATUS_EVENT, handleDisplayRotationStatus);
    }, []);

    useEffect(() => {
        if (performLiveInfo.teacher_info && performLiveInfo.teacher_info.userSeq > 0) {
            setTeacherInfo({
                userSeq: performLiveInfo.teacher_info.userSeq,
                userNickname: performLiveInfo.teacher_info.userNickname
            });
        }
    }, [performLiveInfo.teacher_info]);

    useEffect(() => {
        // 20251110 ... 더보기 상태값 초기화를 위해 호출 ... by hjkim
        if (performLiveInfo.liveSeq >= 0 && performLiveInfo.liveStatus === "N") {
            handleSelectedLiveFunc({ selectedFunc: "TOGGLE_PUBLIC_CLASS" });
        }
    }, [performLiveInfo.liveSeq, performLiveInfo.liveStatus]);

    useEffect(() => {
        // 20261001 더보기 또는 다른 기존 옵션을 닫으면 소리 설정 패널도 함께 닫는다.
        if (optionVisibility !== "flex") {
            setIsAudioSourceSettingsOpen(false);
            setAudioSourceSettingsMessage("");
        }
    }, [optionVisibility]);

    useEffect(() => {
        // 20261001 Android native Bridge는 실제 믹서 적용 후에만 결과를 회신하므로 그 값을 UI에 반영한다.
        const handleAudioSourceSettingsResult = (event) => {
            const result = event.detail || {};
            if (audioSourceSettingsRequestRef.current && result.requestId !== audioSourceSettingsRequestRef.current) return;

            audioSourceSettingsRequestRef.current = "";
            if (audioSourceSettingsTimeoutRef.current) window.clearTimeout(audioSourceSettingsTimeoutRef.current);
            setPendingAudioSourceSettingsRequestId("");
            if (result.success) {
                setAudioSourceSettingsState({
                    microphoneIncluded: result.microphoneIncluded !== false,
                    systemAudioIncluded: result.systemAudioIncluded !== false
                });
                setAudioSourceSettingsMessage("");
            } else {
                setAudioSourceSettingsMessage(result.reason || "소리 설정을 적용하지 못했습니다.");
            }
        };

        window.addEventListener("handsUpAudioSourceSettingsResult", handleAudioSourceSettingsResult);
        return () => window.removeEventListener("handsUpAudioSourceSettingsResult", handleAudioSourceSettingsResult);
    }, []);

    useEffect(() => {
        // 20261001 교사 요청 적용 결과는 패널의 자체 요청과 별도로 수신해 열린 설정 UI를 즉시 동기화한다.
        const handleAudioSourceSettingsApplied = (event) => {
            const result = event.detail || {};
            if (result.success !== true) return;
            setAudioSourceSettingsState({
                microphoneIncluded: result.microphoneIncluded !== false,
                systemAudioIncluded: result.systemAudioIncluded !== false
            });
            setAudioSourceSettingsMessage("");
        };

        window.addEventListener("handsUpAudioSourceSettingsApplied", handleAudioSourceSettingsApplied);
        return () => window.removeEventListener("handsUpAudioSourceSettingsApplied", handleAudioSourceSettingsApplied);
    }, []);

    useEffect(() => () => {
        // 20261001 화면 종료 뒤 늦은 Android Bridge 응답 대기 타이머가 상태를 갱신하지 않도록 정리한다.
        if (audioSourceSettingsTimeoutRef.current) window.clearTimeout(audioSourceSettingsTimeoutRef.current);
    }, []);

    useEffect(() => {
        if (!isAudioSourceSettingsOpen) return undefined;

        // 20261001 기존 더보기 외부를 누르면 소리 설정 패널만 닫고 기존 도구 클릭은 그대로 진행한다.
        const handleOutsideAudioSourceSettingsClick = (event) => {
            if (audioSourceSettingsContainerRef.current && !audioSourceSettingsContainerRef.current.contains(event.target)) {
                setIsAudioSourceSettingsOpen(false);
                setAudioSourceSettingsMessage("");
            }
        };

        document.addEventListener("mousedown", handleOutsideAudioSourceSettingsClick);
        return () => document.removeEventListener("mousedown", handleOutsideAudioSourceSettingsClick);
    }, [isAudioSourceSettingsOpen]);

    const toggleFullScreenMode = () => {
        if (!teacherViewVisibility) return;

        if (performLiveStatusInfo.isConnect) {
            handleSelectedLiveFunc({ selectedFunc: "CHANGE_VIEW_SIZE" });
        }
    }

    const toggleOptionMode = () => {

    }

    const requestAndroidAudioSourceSettings = (operation, settings = {}) => {
        const requestId = `audio-source-${Date.now()}-${Math.random().toString(36).slice(2)}`;
        const processComm = window.ProcessComm;
        if (!processComm || typeof processComm.requestAudioSourceSettings !== "function") {
            setAudioSourceSettingsMessage("현재 앱 버전에서는 소리 설정을 지원하지 않습니다.");
            return;
        }

        if (audioSourceSettingsTimeoutRef.current) window.clearTimeout(audioSourceSettingsTimeoutRef.current);
        audioSourceSettingsRequestRef.current = requestId;
        setPendingAudioSourceSettingsRequestId(requestId);
        setAudioSourceSettingsMessage("");
        processComm.requestAudioSourceSettings(JSON.stringify({ operation, requestId, ...settings }));
        audioSourceSettingsTimeoutRef.current = window.setTimeout(() => {
            if (audioSourceSettingsRequestRef.current !== requestId) return;
            audioSourceSettingsRequestRef.current = "";
            setPendingAudioSourceSettingsRequestId("");
            setAudioSourceSettingsMessage("앱 소리 설정 응답을 받지 못했습니다.");
        }, 3000);
    };

    // 261015 iOS 앱(ProAudioMixDevice)에 소리 설정(get/set)을 요청한다. 결과는 handsUpAudioSourceSettingsResult 이벤트로 받는다.
    const requestIOSAudioSourceSettings = (operation, settings = {}) => {
        const requestId = `audio-source-${Date.now()}-${Math.random().toString(36).slice(2)}`;
        const handler = window.webkit?.messageHandlers?.screenShareHandler;
        if (!handler) {
            setAudioSourceSettingsMessage("현재 앱 버전에서는 소리 설정을 지원하지 않습니다.");
            return;
        }

        if (audioSourceSettingsTimeoutRef.current) window.clearTimeout(audioSourceSettingsTimeoutRef.current);
        audioSourceSettingsRequestRef.current = requestId;
        setPendingAudioSourceSettingsRequestId(requestId);
        setAudioSourceSettingsMessage("");
        handler.postMessage({ action: "pro-audioSourceSettings", data: { operation, requestId, ...settings } });
        audioSourceSettingsTimeoutRef.current = window.setTimeout(() => {
            if (audioSourceSettingsRequestRef.current !== requestId) return;
            audioSourceSettingsRequestRef.current = "";
            setPendingAudioSourceSettingsRequestId("");
            setAudioSourceSettingsMessage("앱 소리 설정 응답을 받지 못했습니다.");
        }, 3000);
    };

    const handleOpenAudioSourceSettings = () => {
        const willOpen = !isAudioSourceSettingsOpen;
        setIsAudioSourceSettingsOpen(willOpen);
        setAudioSourceSettingsMessage("");
        if (!willOpen) return;

        if (isAndroidClient) {
            requestAndroidAudioSourceSettings("get");
        } else if (isIOSLegacyApp) {
            // [261015-IOS-COMPAT] 이전 앱: 기존 20261001 안내 유지
            setAudioSourceSettingsMessage("iOS 앱 소리 설정 연동 후 사용할 수 있습니다.");
        } else if (isIOSClient) {
            // 261015 iOS 앱 소리 설정 연동 완료 - 앱의 실제 적용값을 조회한다.
            // (기존 20261001: "iOS 앱 소리 설정 연동 후 사용할 수 있습니다." 안내만 표시)
            requestIOSAudioSourceSettings("get");
        } else {
            setAudioSourceSettingsState(getAudioSourceSettings());
        }
    };

    const handleChangeAudioSourceSetting = (key, value) => {
        if (isIOSLegacyApp) return; // [261015-IOS-COMPAT] 이전 앱: 기존과 동일하게 변경 불가

        // 261015 iOS 앱 소리 설정 연동 (기존: if (isIOSClient) return;)
        if (isIOSClient) {
            requestIOSAudioSourceSettings("set", { [key]: value });
            return;
        }

        if (isAndroidClient) {
            requestAndroidAudioSourceSettings("set", { [key]: value });
            return;
        }

        const result = setAudioSourceSettings({ [key]: value });
        if (result.success) {
            setAudioSourceSettingsState(result);
            setAudioSourceSettingsMessage("");
        } else {
            setAudioSourceSettingsMessage("소리 설정을 적용하지 못했습니다.");
        }
    };

    const isAudioSettingsPending = pendingAudioSourceSettingsRequestId !== "";
    const audioSettingsOptionRight = ConstData.IS_LOCAL_VERSION ? 325 : 0;
    const moreButtonRight = optionVisibility === "flex" ? (ConstData.IS_LOCAL_VERSION ? 415 : 95) : 0;

    return (
        <div className="live-toolbar-area bottom small" style={{ backgroundColor: 'white' }}>
            <div className="toolbar-landscape">
                <div className="d-flex"
                    data-toggle="tooltip"
                    title={classTalkVisibility === "hidden" ? `${t("클래스톡", { ns: "classTalk" })} ${t("열기", { ns: "common" })}` : `${t("클래스톡", { ns: "classTalk" })} ${t("닫기", { ns: "common" })}`}
                >
                    <button
                        type="button"
                        className={"hiclasstv-button" + (isClassTalkNotifying ? " blink-notify" : "")}
                        style={{ minWidth: '44px' }}
                        onClick={() => handleSelectedLiveFunc({ selectedFunc: "TOGGLE_CLASSTALK" })}>
                        <img
                            className="hiclasstv-live-icon"
                            src={classTalkVisibility === "hidden" ? "/images/liveTool/hideClasstalk.png" : "/images/liveTool/showClasstalk.png"}
                            alt={classTalkVisibility === "hidden" ? `${t("클래스톡", { ns: "classTalk" })} ${t("열기", { ns: "common" })}` : `${t("클래스톡", { ns: "classTalk" })} ${t("닫기", { ns: "common" })}`}
                            aria-hidden="true"
                        />
                        <span className="hiclasstv-live-text">{t("채팅방", { ns: "chat" })}</span>
                    </button>
                </div>
                <div className="d-flex"
                    data-toggle="tooltip"
                    title={teacherViewVisibility === "hidden" ? t("화면_보기", { ns: "live" }) : t("화면_닫기", { ns: "live" })}
                >
                    <button type="button" className="hiclasstv-button"
                        onClick={() => handleSelectedLiveFunc({ selectedFunc: "TOGGLE_TEACHER_VIEW" })}>
                        <img
                            className="hiclasstv-live-icon"
                            src={teacherViewVisibility === "hidden" ? "/images/liveTool/hideTeacherScreen.png" : "/images/liveTool/showTeacherScreen.png"}
                            alt={teacherViewVisibility === "hidden" ? t("화면_보기", { ns: "live" }) : t("화면_닫기", { ns: "live" })}
                            aria-hidden="true"
                        />
                        <span className="hiclasstv-live-text">{t("화면숨김", { ns: "live" })}</span>
                    </button>
                </div>
                <div className="d-flex"
                    data-toggle="tooltip"
                    title={isFullScreenMode ? t("전체화면_종료", { ns: "live" }) : t("전체화면", { ns: "live" })}
                >
                    <button type="button" className="hiclasstv-button" style={{ minWidth: '44px' }}
                        /* data-toggle="tooltip" */
                        /* title={isFullScreenMode ? "전체화면 종료" : "전체화면"} */
                        disabled={!performLiveStatusInfo.isConnect || teacherViewVisibility === "hidden"}
                        onClick={() => toggleFullScreenMode()}>
                        {
                            /* (!performLiveStatusInfo.isConnect || teacherViewVisibility === "hidden") ?
                                <FaExpandArrowsAlt className="font-ml" style={{ color: 'rgb(158, 158, 158)' }} aria-hidden="true" title="전체화면" /> :
                                isFullScreenMode ?
                                    <FaCompressArrowsAlt className="font-ml" style={{ color: 'rgb(55, 230, 71)' }} aria-hidden="true" title="전체화면 종료" /> :
                                    <FaExpandArrowsAlt className="font-ml" style={{ color: 'rgb(55, 230, 71)' }} aria-hidden="true" title="전체화면" /> */
                            performLiveStatusInfo.isConnect && isFullScreenMode && teacherViewVisibility !== "hidden" ?
                                <img
                                    className="hiclasstv-live-icon"
                                    src="/images/liveTool/minScreen.png"
                                    alt={t("전체화면_종료", { ns: "live" })}
                                    aria-hidden="true"
                                /> :
                                <img
                                    className="hiclasstv-live-icon"
                                    src={(!performLiveStatusInfo.isConnect || teacherViewVisibility === "hidden") ? "/images/liveTool/maxScreenDisable.png" : "/images/liveTool/maxScreen.png"}
                                    alt={t("전체화면", { ns: "live" })}
                                    aria-hidden="true"
                                /> 
                        }
                        <span className="hiclasstv-live-text">{t("화면전환", { ns: "live" })}</span>
                    </button>
                </div>
                <div className="d-flex"
                    data-toggle="tooltip"
                    title={performHandsUpStatusInfo.micStatus === "disable" || performHandsUpStatusInfo.micStatus === "off" ? t("음성_켜기", { ns: "live" }) : t("음성_끄기", { ns: "live" })}
                >
                    <button id="btnChangeMicStatus" type="button" className="hiclasstv-button" disabled={performHandsUpStatusInfo.micStatus === "disable" || performHandsUpStatusInfo.micStatus === "muteDisable" ? true : false} onClick={() => handleSelectedLiveFunc({ selectedFunc: "PROC_MIC" })}>
                        {
                            /* performHandsUpStatusInfo.micStatus === "disable" || performHandsUpStatusInfo.micStatus === "off" ?
                                <img src="/images/liveTool/micOffDisable.png" aria-hidden="true" className="hiclasstv-live-icon" title="음성 켜기" alt="음성 켜기" /> :
                                // performHandsUpStatusInfo.micStatus === "off" ?
                                //     <img src="/images/liveTool/micOffDisable.png" aria-hidden="true" className="hiclasstv-live-icon" title="음성 켜기" alt="음성 켜기" /> :
                                performHandsUpStatusInfo.micStatus === "mute" ?
                                    <img src="/images/liveTool/micOn.png" aria-hidden="true" className="hiclasstv-live-icon" title="음성 끄기" alt="음성 끄기" /> :
                                    <img src="/images/liveTool/micOnDisable.png" aria-hidden="true" className="hiclasstv-live-icon" title="음성 끄기" alt="음성 끄기" /> */
                        }
                        <img
                            className="hiclasstv-live-icon"
                            src={performHandsUpStatusInfo.micStatus === "disable" || performHandsUpStatusInfo.micStatus === "off" ? "/images/liveTool/micOffDisable.png" : performHandsUpStatusInfo.micStatus === "mute" ? "/images/liveTool/micOn.png" : "/images/liveTool/micOnDisable.png"}
                            /* title={performHandsUpStatusInfo.micStatus === "disable" || performHandsUpStatusInfo.micStatus === "off" ? "음성 켜기" : "음성 끄기"} */
                            alt={performHandsUpStatusInfo.micStatus === "disable" || performHandsUpStatusInfo.micStatus === "off" ? t("음성_켜기", { ns: "live" }) : t("음성_끄기", { ns: "live" })}
                            aria-hidden="true"
                        />
                        <span className="hiclasstv-live-text">{t("학생소리", { ns: "live" })}</span>
                    </button>
                </div>
                <div className="d-flex"
                    data-toggle="tooltip"
                    title={(performHandsUpStatusInfo.connectStatus === "disable" || performHandsUpStatusInfo.connectStatus === "disconnect") ? t("연결하기", { ns: "live" }) : t("연결중", { ns: "live" })}
                >
                    <button type="button" className="hiclasstv-button" disabled={(performLiveInfo.handsUpYN !== "Y" && performHandsUpStatusInfo.connectStatus === "disable")} onClick={() => handleSelectedLiveFunc({ selectedFunc: "PROC_CONN" })}>
                        {
                            /* performHandsUpStatusInfo.connectStatus === "disable" ?
                                <img src="/images/liveTool/disconnectDisable.png" aria-hidden="true" className="hiclasstv-live-icon" title="연결하기" alt="연결하기" /> :
                                performHandsUpStatusInfo.connectStatus === "disconnect" ?
                                    <img src="/images/liveTool/disconnect.png" aria-hidden="true" className="hiclasstv-live-icon" title="연결하기" alt="연결하기" /> :
                                    <img src="/images/liveTool/connectAble.png" aria-hidden="true" className="hiclasstv-live-icon" title="연결중" alt="연결중" /> */
                        }
                        <img
                            className="hiclasstv-live-icon"
                            src={performHandsUpStatusInfo.connectStatus === "disable" ? "/images/liveTool/disconnectDisable.png" : performHandsUpStatusInfo.connectStatus === "disconnect" ? "/images/liveTool/disconnect.png" : "/images/liveTool/connectAble.png"}
                            /* title={(performHandsUpStatusInfo.connectStatus === "disable" || performHandsUpStatusInfo.connectStatus === "disconnect") ? "연결하기" : "연결중"} */
                            alt={(performHandsUpStatusInfo.connectStatus === "disable" || performHandsUpStatusInfo.connectStatus === "disconnect") ? t("연결하기", { ns: "live" }) : t("연결중", { ns: "live" })}
                            aria-hidden="true"
                        />
                        <span className="hiclasstv-live-text">{t("연결상태", { ns: "live" })}</span>
                    </button>
                </div>
                <div className="d-flex"
                    data-toggle="tooltip"
                    title={(performLiveInfo.liveSeq === -1 || performLiveInfo.handsUpYN === "N") || viewKind === "CAMERA" ? t("스크린으로_전환", { ns: "live" }) : t("카메라로_전환", { ns: "live" })}
                >
                    <button id="btnChangeViewKind" type="button" className="hiclasstv-button" style={{ minWidth: '44px' }} disabled={performLiveInfo.handsUpYN !== "Y" ? true : false} onClick={() => handleSelectedLiveFunc({ selectedFunc: "CHANGE_VIEW_KIND" })}>
                        {
                            /* (performLiveInfo.liveSeq === -1 || performLiveInfo.handsUpYN === "N") ?
                                <FaCamera className="font-ml" style={{ color: 'rgb(158, 158, 158)' }} aria-hidden="true" title="스크린으로 전환" /> :
                                viewKind === "CAMERA" ?
                                    <FaCamera className="font-ml" style={{ color: 'rgb(55, 230, 71)' }} aria-hidden="true" title="스크린으로 전환" /> :
                                    <FaDesktop className="font-ml" style={{ color: 'rgb(55, 230, 71)' }} aria-hidden="true" title="카메라로 전환" /> */
                            (performLiveInfo.liveSeq === -1 || performLiveInfo.handsUpYN === "N" || isIOSWebView()) || viewKind === "CAMERA" ?
                                <img
                                    className="hiclasstv-live-icon"
                                    src={(performLiveInfo.liveSeq === -1 || performLiveInfo.handsUpYN === "N" || isIOSWebView()) ? "/images/liveTool/transCamDisable.png" : "/images/liveTool/transCam.png"}
                                    alt={t("스크린으로_전환", { ns: "live" })}
                                    aria-hidden="true"
                                /> : 
                                <img
                                    className="hiclasstv-live-icon"
                                    src="/images/liveTool/screenMode.png"
                                    alt={t("스크린으로_전환", { ns: "live" })}
                                    aria-hidden="true"
                                />
                                /*<FaCamera className="font-ml" style={{ color: (performLiveInfo.liveSeq === -1 || performLiveInfo.handsUpYN === "N") ? 'rgb(158, 158, 158)' : 'rgb(55, 230, 71)' }} alt={t("스크린으로_전환", { ns: "live" })} aria-hidden="true" /> :
                                    <FaDesktop className="font-ml" style={{ color: 'rgb(55, 230, 71)' }} alt={t("카메라로_전환", { ns: "live" })} aria-hidden="true" />*/
                        }
                        <span className="hiclasstv-live-text">{t("공유선택", { ns: "live" })}</span>
                    </button>
                </div>
                {
                    /* (performLiveInfo.handsUpYN === "Y" && lHandsUpVisibility === "visible") &&
                    <div className="d-flex"
                        data-toggle="tooltip"
                        title="저요저요"
                    >
                        <button type="button" className="d-flex hiclasstv-button hiclasstv-grey rounded ml-1 p-2" onClick={() => handleSelectedLiveFunc({ selectedFunc: "HANDS_UP" })}>
                            <FaHandPaper className={"font-md" + (performHandsUpStatusInfo.myHandsUpYN === "Y" ? " hiclasstv-yellow-text icon-gradation" : " white-text")} alt="저요저요" aria-hidden="true" />
                        </button>
                    </div> */
                }
                {
                    performLiveInfo.liveSeq > 0 && performLiveInfo.handsUpYN === "Y" &&
                    <div className="d-flex"
                        data-toggle="tooltip"
                        title={(viewKind === "CAMERA" || myCamViewVisibility === "none") ? t("마이_캠_켜기", { ns: "live" }) : t("마이_캠_끄기", { ns: "live" })}
                    >
                        <button type="button" className="hiclasstv-button" style={{ minWidth: '44px' }} disabled={viewKind !== "SCREEN"} onClick={() => handleSelectedLiveFunc({ selectedFunc: "TOGGLE_MYCAM_VIEW" })}>
                            {
                                /* viewKind !== "SCREEN" ?
                                    <FaPortrait className="font-ml" style={{ color: 'rgb(158, 158, 158)' }} aria-hidden="true" title="마이 캠 켜기" /> :
                                    myCamViewVisibility === "none" ?
                                        <FaPortrait className="font-ml" style={{ color: 'rgb(255, 0, 0)' }} aria-hidden="true" title="마이 캠 켜기" /> :
                                        <FaPortrait className="font-ml" style={{ color: 'rgb(55, 230, 71)' }} aria-hidden="true" title="마이 캠 끄기" /> */
                            }
                            <img
                                className="hiclasstv-live-icon"
                                src={(viewKind === "CAMERA") ? "/images/liveTool/myCamDisable.png" : (myCamViewVisibility === "none") ? "/images/liveTool/myCamDisable.png" : "/images/liveTool/myCam.png"}
                                alt={(viewKind === "CAMERA" || myCamViewVisibility === "none") ? t("마이_캠_켜기", { ns: "live" }) : t("마이_캠_끄기", { ns: "live" })}
                                aria-hidden="true"
                            />
                            <span className="hiclasstv-live-text">{t("마이캠", { ns: "live" })}</span>
                        </button>
                    </div>
                }
                {
                    // 260916 화면 보정 기능: 학생이 자신의 화면 공유 producer가 실제로 회전되어
                    // 보인다고 판단될 때, 직접 90/180/270도 보정값을 선택해서 서버(선생님)로 즉시 전달한다.
                    // 260916 iOS WebView로 접속한 경우에만 노출한다.
                    // 20260916 PBLGroup: 화면 보정 기능이 정상 동작하지 않아 원인 파악 전까지 전체 플랫폼에서 버튼을 임시로 숨긴다.
                    false && performLiveInfo.liveSeq > 0 && isIOSWebView() &&
                    <div className="d-flex" style={{ position: "relative" }} data-toggle="tooltip" title={t("화면_보정", { ns: "live" })}>
                        <button id="btnScreenCorrection" type="button" className="hiclasstv-button" style={{ minWidth: '44px' }}
                            onClick={() => setIsScreenCorrectionMenuOpen(prev => !prev)}>
                            <img
                                className="hiclasstv-live-icon"
                                src="/images/liveTool/screenConfig.png"
                                alt={t("화면_보정", { ns: "live" })}
                                aria-hidden="true"
                            />
                            <span className="hiclasstv-live-text">{t("화면_보정", { ns: "live" })}</span>
                        </button>
                        {isScreenCorrectionMenuOpen &&
                            <div className="hiclasstv-screen-correction-menu" style={{
                                position: "absolute",
                                bottom: "100%",
                                left: 0,
                                marginBottom: "4px",
                                display: "flex",
                                flexDirection: "column",
                                background: "rgba(0, 0, 0, 0.85)",
                                borderRadius: "4px",
                                overflow: "hidden",
                                zIndex: 10
                            }}>
                                {[0, 90, 180, 270].map((rotation) => (
                                    <button key={rotation} type="button"
                                        className="hiclasstv-screen-correction-option"
                                        style={{
                                            color: selectedDisplayRotation === rotation ? "rgb(55, 230, 71)" : "white",
                                            background: "transparent",
                                            border: "none",
                                            padding: "6px 16px",
                                            whiteSpace: "nowrap",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => handleSelectDisplayRotation(rotation)}>
                                        {rotation}°
                                    </button>
                                ))}
                            </div>
                        }
                    </div>
                }
                <div className="d-flex align-items-center w-100">
                    {
                        performLiveInfo.liveSeq !== -1 &&
                        <div className="d-flex align-items-center" style={{ minWidth: '1%', width: '100%', maxWidth: 'max-content' }}>
                            <span className="web-list-text w-100 px-1" title={`[${t("진행자", { ns: "live" })}] ${teacherInfo.userNickname}`}><b>{teacherInfo.userNickname}&nbsp;&nbsp;</b></span>|
                        </div>
                    }
                    <div className="d-flex" style={{ minWidth: '10%', width: '100%', maxWidth: 'max-content', visibility: 'visible' }}>
                        <span className="web-list-text w-100 px-1" title={`[${t("나", { ns: "common" })}] ${userNickname}`}>{userNickname}</span>
                        {isScreenRotationSending &&
                            <span className="live-screen-rotation-status" title={t("화면_보정_송출_안내", { ns: "live" })}>
                                <TbDeviceDesktopUp aria-hidden="true" />
                                <span>{t("화면_보정_송출", { ns: "live" })}</span>
                            </span>
                        }
                    </div>
                </div>
                {
                    <div className="d-flex"
                        data-toggle="tooltip"
                        // 260803 확장 메뉴가 ClassMonitor 상태 버튼까지 포함한 메뉴와 겹치지 않도록 이동한다.
                        style={{ position: 'absolute', right: moreButtonRight }}>
                        <button type="button" className="hiclasstv-button" style={{ minWidth: '44px', minHeight: '44px' }}
                            onClick={() => handleSelectedLiveFunc({ selectedFunc: "TOGGLE_OPTION_VIEW" })}>
                            <BsThreeDots className="font-md plus" />
                            <span className="hiclasstv-live-text">{t("더보기", { ns: "common" })}</span>
                        </button>
                    </div>
                }
                {
                    ConstData.IS_LOCAL_VERSION && optionVisibility === "flex" &&
                    // 260803 ClassMonitor 회신 상태에 맞춰 학생이 최대화/최소화 목표 JSON을 전송한다.
                    <div className="d-flex"
                        data-toggle="tooltip"
                        style={{ position: 'absolute', right: '235px' }}
                        title={isClassMonitorMaximized ? "모니터 화면 최소화" : "모니터 화면 최대화"}
                    >
                        <button type="button" className="hiclasstv-button" style={{ minWidth: '44px', width:'85px' }}
                            onClick={() => handleSelectedLiveFunc({ selectedFunc: "SET_CLASS_MONITOR_SCREEN_MODE", data: { isMaximized: !isClassMonitorMaximized } })}>
                            {isClassMonitorMaximized
                                ? <FaCompressArrowsAlt style={{ color:'#095EA4', fontSize:'1.5rem' }}/>
                                : <FaExpandArrowsAlt style={{ color:'#095EA4', fontSize:'1.5rem' }}/>
                            }
                            <span className="hiclasstv-live-text">{isClassMonitorMaximized ? "모니터 최소화" : "모니터 최대화"}</span>
                        </button>
                    </div>
                }
                {
                    ConstData.IS_LOCAL_VERSION && optionVisibility === "flex" &&
                    <div className="d-flex"
                        data-toggle="tooltip"
                        style={{ position: 'absolute', right: '145px' }}
                        title={t("스마트_티브이_최대화", { ns: "live" })}
                    >
                        <button type="button" className="hiclasstv-button" style={{ minWidth: '44px', width:'85px' }}
                            onClick={() => handleSelectedLiveFunc({ selectedFunc: "SEND_SMART_TV_MAX" })}>
                            <TbDeviceDesktopUp  style={{ color:'#095EA4', fontSize:'1.5rem'}}/>
                            <span className="hiclasstv-live-text">{t("스마트_티브이_최대화", { ns: "live" })}</span>
                        </button>
                    </div>
                }
                {
                    ConstData.IS_LOCAL_VERSION && optionVisibility === "flex" &&
                    // 260728 SmartTV 최대화와 분리된 학생 강의 확대 승인 요청 버튼
                    <div className="d-flex"
                        data-toggle="tooltip"
                        style={{ position: 'absolute', right: '55px' }}
                        title="학생 강의 화면 확대 요청"
                    >
                        <button type="button" className="hiclasstv-button" style={{ minWidth: '44px', width:'85px' }}
                            onClick={() => handleSelectedLiveFunc({ selectedFunc: "REQUEST_PRESENTATION_STUDENT" })}>
                            <FaDesktop style={{ color:'#095EA4', fontSize:'1.5rem' }}/>
                            <span className="hiclasstv-live-text">학생 강의 요청</span>
                        </button>
                    </div>
                }
                {
                    ConstData.IS_LOCAL_VERSION && optionVisibility === "flex" &&
                    <div className="d-flex"
                        data-toggle="tooltip"
                        style={{ position: 'absolute', right: 0 }}
                        title={publicClassVisibility === "hidden" ? `${t("수업_음성_끄기", { ns: "live" })}` : `${t("수업_음성_켜기", { ns: "live" })}`}
                    >
                        <button type="button" className="hiclasstv-button" style={{ minWidth: '44px' }}
                            onClick={() => handleSelectedLiveFunc({ selectedFunc: "TOGGLE_PUBLIC_CLASS" })}>
                            <img
                                className="hiclasstv-live-icon"
                                src={publicClassVisibility === "hidden" ? "/images/liveTool/green_soundOn.png" : "/images/liveTool/disable_soundOn.png"}
                                alt={publicClassVisibility === "hidden" ? `${t("수업_음성_끄기", { ns: "live" })}` : `${t("수업_음성_켜기", { ns: "live" })}`}
                                aria-hidden="true"
                            />
                            <span className="hiclasstv-live-text">{t("수업_음성", { ns: "live" })}</span>
                        </button>
                    </div>
                }
                {
                    optionVisibility === "flex" &&
                    <div className="d-flex"
                        ref={audioSourceSettingsContainerRef}
                        data-toggle="tooltip"
                        style={{ position: 'absolute', right: audioSettingsOptionRight }}
                        title="소리 설정"
                    >
                        <button type="button" className="hiclasstv-button" style={{ minWidth: '44px', width: '85px' }}
                            onClick={handleOpenAudioSourceSettings}>
                            <FaVolumeUp style={{ color:'#095EA4', fontSize:'1.5rem' }}/>
                            <span className="hiclasstv-live-text">소리 설정</span>
                        </button>
                        {isAudioSourceSettingsOpen &&
                            <div style={{
                                position: "absolute",
                                right: 0,
                                bottom: "calc(100% + 8px)",
                                width: "250px",
                                padding: "14px",
                                color: "white",
                                background: "rgba(20, 28, 38, 0.96)",
                                border: "1px solid #095EA4",
                                borderRadius: "6px",
                                zIndex: 40
                            }}>
                                <div style={{ fontWeight: "bold", marginBottom: "10px" }}>소리 설정</div>
                                <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px", cursor: isIOSLegacyApp ? "default" : "pointer" }}>{/* [261015-IOS-COMPAT] 이전 앱만 변경 불가 (기존: isIOSClient ? "default" : "pointer") */}
                                    <span>마이크 포함</span>
                                    <input type="checkbox" checked={audioSourceSettings.microphoneIncluded}
                                        disabled={isIOSLegacyApp /* [261015-IOS-COMPAT] 이전 앱만 비활성 */ || isAudioSettingsPending}
                                        onChange={(event) => handleChangeAudioSourceSetting("microphoneIncluded", event.target.checked)} />
                                </label>
                                {/* 261015 iOS 앱도 시스템 소리 포함 지원 (기존: !isIOSClient &&) / [261015-IOS-COMPAT] 이전 앱은 숨김 */}
                                {!isIOSLegacyApp &&
                                    <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px", cursor: "pointer" }}>
                                        <span>시스템 소리 포함</span>
                                        <input type="checkbox" checked={audioSourceSettings.systemAudioIncluded}
                                            disabled={isAudioSettingsPending}
                                            onChange={(event) => handleChangeAudioSourceSetting("systemAudioIncluded", event.target.checked)} />
                                    </label>
                                }
                                {audioSourceSettingsMessage &&
                                    <div style={{ color: "#ffd166", fontSize: "0.78rem", lineHeight: 1.35 }}>{audioSourceSettingsMessage}</div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>

            {/* 가로로 화면 전환하라는 안내문구 띄우기 */}
            <div className="toolbar-portrait">
                <div className="d-flex red justify-content-center w-100 px-1">
                    <span className="white-text">※ {t("채팅", { ns: "chat" })}{performLiveStatusInfo.isConnect ? t("세로모드_안내_문구_1", { ns: "live" }) : ""}{t("세로모드_안내_문구_2", { ns: "live" })}</span>
                </div>
                <div className="d-flex align-items-center">
                    {
                        performLiveInfo.liveSeq !== -1 &&
                        <div className="d-flex align-items-center" style={{ minWidth: '1%', width: '100%', maxWidth: 'max-content' }}>
                            <span className="web-list-text w-100 px-1" title={`[${t("진행자", { ns: "live" })}] ${teacherInfo.userNickname}`}><b>{teacherInfo.userNickname}&nbsp;&nbsp;</b></span>|
                        </div>
                    }
                    <div className="d-flex" style={{ minWidth: '10%', width: '100%', maxWidth: 'max-content', visibility: 'visible' }}>
                        <span className="web-list-text w-100 px-1" title={`[${t("나", { ns: "common" })} ] ${userNickname}`}>{userNickname}</span>
                        {isScreenRotationSending &&
                            <span className="live-screen-rotation-status" title={t("화면_보정_송출_안내", { ns: "live" })}>
                                <TbDeviceDesktopUp aria-hidden="true" />
                                <span>{t("화면_보정_송출", { ns: "live" })}</span>
                            </span>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LiveControlTool;
